var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column user-dashboard",style:(_vm.panelStyles)},[_c('theme-scene',{attrs:{"theme":_vm.theme}}),_c('profile-stats',{attrs:{"db-info":_vm.dbInfo,"overlay-styles":_vm.overlayStyles,"accent":_vm.theme.colors.accent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }